import React, { useEffect, useRef, useState } from 'react';
import './progress-display-container.styles.scss';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getCompiledDataFromDb, getMcDataFromDb, getProgressFromDb, getUniqueDocFromDb } from '@/utils/getDataFromDb';
import ProgressHeader from '@/components/SHARED/progress-header/progress-header.component';
import BackButton from '@/components/back-button/back-button.component';
import ProgressContentItem from './progress-content-item.component';
import { format } from 'date-fns';
import { properCase } from '@/utils/properCase';
import { UseCloudFunction } from '@/utils/firebase.utils';
import { useSelector } from 'react-redux';
import { RandomString } from '@/utils/randomString';
import { createPurchaseDataPoint } from '@/utils/create-purchase-data-point';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faPrint, faUpload } from '@fortawesome/free-solid-svg-icons';
import ProgressSummary from './progress-summary.component';
import AllUploadsModal from '@/components/SHARED/all-uploads-modal/all-uploads-modal.component';
import { ModalAlert, ModalConfirm } from '@/components/SHARED/modal/modal.component';

const ProgressDisplayContainer = () => {

  const userProfile = useSelector(state => state.userData.userProfile);
  const { progressId } = useParams();
  const [progress, setProgress] = useState(null);
  const [user, setUser] = useState(null);
  const [mcData, setMcData] = useState(null);
  const [content, setContent] = useState(null);
  const [progressValue, setProgressValue] = useState(0);
  const [approvalValue, setApprovalValue] = useState(0);
  const [timeline, setTimeline] = useState(null);
  const [mcStatus, setMcStatus] = useState(null);
  const [viewUploads, setViewUploads] = useState(false);
  const [contentCount, setContentCount] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState(null);
  const approveRef = useRef();
  const timelineRef = useRef();
  const location = useLocation();
  let progressListener;
  let timelineListener;
  const navigate = useNavigate();

  useEffect(() => {

    return () => {
      if (progressListener) progressListener();
      if (timelineListener) timelineListener();
    }
  }, [])

  useEffect(() => {
    if (!progressId) return;
    getProgress();
  }, [progressId])

  useEffect(() => {
    if (!mcData || !progress) return;
    setUpContent();
    // getStatus();
    // getTimeline();
  }, [mcData, progress])

  function getProgress() {
    let mc_key = progressId.split('_')[0];
    let cst_key = progressId.split('_')[1];
    getUser(cst_key);
    getMcData(mc_key);
    getProgressFromDb({
      'cst_key': cst_key,
      'mc_key': mc_key,
      'callback': callback,
      'handleListener': handleListener
    })
    function callback(data) {
      setProgress(data);
    }
    function handleListener(unsub) {
      progressListener = unsub;
    }
  }

  function getUser(cst_key) {
    getUniqueDocFromDb({
      'path': `users/${cst_key}`,
      'callback': callback,
      'once': true
    })
    function callback(data) {
      setUser(data);
    }
  }

  function getMcData(mc_key) {
    getUniqueDocFromDb({
      'path': `mcs/${mc_key}`,
      'callback': callback,
      'once': true
    })
    function callback(data) {
      setMcData(data);
    }
  }

  // function getTimeline() {
  //     getPurchaseDate();
  //     getCompiledDataFromDb({
  //         'progressId': progressId,
  //         'callback': callback,
  //         'handleListener': handleListener
  //     })
  //     function callback(data) {
  //         timelineRef.current = {
  //             ...timelineRef.current,
  //             ...{[data.id]: data}
  //         }
  //         setTimeline(timelineRef.current);
  //     }
  //     function handleListener(unsub) {
  //         timelineListener = unsub;
  //     }
  // }

  // async function getPurchaseDate() {
  //     const res = await UseCloudFunction(
  //         'getMcUserListFromNfe',
  //         {
  //             'profile': userProfile,
  //             'mcData': mcData
  //         }
  //     )
  //     console.log(res);
  //     const purchase = res.filter(r => r.cst_key === user.cst_key)[0];
  //     if (!purchase) return;
  //     const obj = createPurchaseDataPoint(purchase,user,mcData);
  //     console.log(obj);
  //     // let ts = new Date(purchase.add_date).getTime();
  //     // let usercode = user.cst_key.substring(0,8);
  //     // let obj = {
  //     //     'cst_key': user.cst_key,
  //     //     'fName': user.fName,
  //     //     'id': `${ts}-${usercode}-${RandomString(8)}`,
  //     //     'lName': user.lName,
  //     //     'mc_key': mcData.mc_key,
  //     //     'progressId': `${mcData.mc_key}_${user.cst_key}`,
  //     //     'ts': ts,
  //     //     'type': 'purchase-completed'
  //     // }
  //     timelineRef.current = {
  //         ...timelineRef.current,
  //         ...{[obj.id]: obj}
  //     }
  //     setTimeline(timelineRef.current);
  // }

  function setUpContent() {
    let tempContent = [
      {
        'num': -1,
        'id': 'materials',
        'name': 'Viewed Required Micro-Credential Materials',
        'desc': '',
        'type': 'content'
      },
      {
        'num': 0,
        'id': 'precheck',
        'name': 'Precheck Artifact and Self-Analysis',
        'desc': '',
        'type': 'content'
      },
      {
        'num': 1,
        'id': 'overview',
        'name': 'Overview Questions',
        'desc': mcData.overview,
        'type': 'content'
      }
    ]
    let elementCount = 2;
    let contCount = 2;
    for (let eo of Object.values(mcData.content).sort((a, b) => a.num > b.num ? 1 : -1)) {
      tempContent.push({
        'num': elementCount,
        'id': eo.id,
        'name': eo.name,
        'desc': eo.desc,
        'type': 'header'
      })
      elementCount++;
      if (eo.comp) {
        for (let comp of Object.values(eo.comp).sort((a, b) => a.id > b.id ? 1 : -1)) {
          tempContent.push({
            'num': elementCount,
            'id': comp.id,
            'name': comp.name,
            'desc': comp.desc,
            'type': 'content'
          })
          contCount++;
          elementCount++;
        }
      }
    }
    tempContent.push({
      'num': elementCount,
      'id': 'closing',
      'name': 'Closing Reflection',
      'desc': mcData.closing,
      'type': 'content'
    })
    contCount++;
    elementCount++;
    setContent(tempContent);
    setContentCount(contCount);
    // let completeCount = 0;
    // let approvedCount = 0;
    // let approved = []
    // for (let p of Object.keys(progress)) {
    //     if (p.includes('content_')) {
    //         completeCount++;
    //         const id = p.replace('content_', '');
    //         if (
    //             progress[p].approved ||
    //             (
    //                 progress[`eval_${id}`] &&
    //                 (
    //                     progress[`eval_${id}`].approved ||
    //                     (
    //                         progress[`eval_${id}`].completed &&
    //                         progress[`eval_${id}`].explained &&
    //                         progress[`eval_${id}`].located
    //                     )
    //                 )
    //             )
    //         ) {
    //             approvedCount++;
    //             approved.push(id);
    //         }
    //     }
    // }
    // console.log(approvedCount);
    // console.log(approved);
    // const compPercent = (((completeCount - 1)/contentCount) * 100).toFixed(0).toLocaleString();
    // setProgressValue(compPercent);
    // const apprPercent = ((approvedCount/contentCount) * 100).toFixed(0).toLocaleString();
    // setApprovalValue(apprPercent);
    // document.getElementById("complete-progress").style.width = compPercent + "%";
    // document.getElementById("approved-progress").style.width = apprPercent + "%";

  }

  function removeUserFromMc() {
    setConfirmMessage('Are you sure you want to remove this user from this Micro-Credential? Doing so will not remove them from the event in NetForum or provide them with a refund.');
    approveRef.current = () => {
      approveRef.current = null;
      continueRemove();
    }

    async function continueRemove() {
      const mcKey = progressId.split('_')[0];
      const cstKey = progressId.split('_')[1];
      const data = {
        'mcKey': mcKey,
        'cstKey': cstKey,
        'userCstKey': userProfile.cst_key,
      }
      const res = await UseCloudFunction(
        'removeUserFromMc',
        data
      )
      console.log(res);
      if (res.error) {
        setAlertMessage('There was an error removing this user from this Micro-Credential. Please try again later.');
        return;
      }
      setAlertMessage('User successfully removed from Micro-Credential.');
      approveRef.current = () => {
        navigate(-1);
      }
    }
  }


  return (
    <div className='progress-display-container'>
      {
        (user && mcData) &&
        <ProgressHeader
          user={user}
          mcData={mcData} />

      }
      <div className="g-space-1"></div>
      {
        (!location.pathname.includes('printable') && mcData && user) &&
        <>
          <div className='buttons'>
            <button
              className='g-button small-btn'
              onClick={() => setViewUploads(true)}>
              View All Uploads
              <FontAwesomeIcon icon={faUpload} />
            </button>
            <Link to={`/printable/${mcData.mc_key}_${user.cst_key}`} target='_blank'>
              <button
                className='g-button small-btn' >
                Print This Page
                <FontAwesomeIcon icon={faPrint} />
              </button>
            </Link>
            <button
              className={`g-button small-btn red ${progress?.deleted ? 'disabled' : ''}`}
              onClick={() => removeUserFromMc()}>
              Remove
              <FontAwesomeIcon icon={faBan} />
            </button>

          </div>
          <div className='g-space-1'></div>
        </>
      }

      <ProgressSummary
        mcData={mcData}
        user={user}
        content={content}
        contentCount={contentCount} />
      {/* <div className='head-grid'>
                <section className='progress-bars'>
                    <div className='g-list-item'>
                        MC Status
                        {
                            (mcStatus) &&
                            <>
                            <div className="g-space-0-5"></div>
                            <div className={`status ${mcStatus.text.replace(' ', '')}`}>
                                {mcStatus.text}
                            </div>
                            <div className='meta'>{mcStatus.date}</div>
                            </>
                        }
                    </div>
                    <div className='progress-with-desc g-list-item'>
                        User Completion
                        <div className="g-space-0-5"></div>
                        <div className='progress-container'>
                            <div className="progress">
                                <div 
                                    className="progress-bar" 
                                    id='complete-progress' 
                                    aria-valuenow={progressValue} 
                                    min="0" 
                                    max="100" >
                                </div>
                            </div>
                            <div className='meta'>{progressValue}%</div>
                        </div>
                    </div>
                    <div className='progress-with-desc g-list-item'>
                        Evaluator Approval
                        <div className="g-space-0-5"></div>
                        <div className='progress-container'>
                            <div className="progress">
                                <div 
                                    className="progress-bar"
                                    id='approved-progress' 
                                    aria-valuenow={approvalValue} 
                                    min="0" 
                                    max="100" >
                                </div>
                            </div>
                            <div className='meta'>{approvalValue}%</div>
                        </div>
                    </div>
                </section>
                <section className='timeline-list g-list-item'>
                Timeline:
                {
                    (timeline) &&
                    Object.values(timeline)
                    .sort((a,b) => a.ts < b.ts ? 1 : -1)
                    .map(t => {
                        return (
                            <div 
                                key={t.id}
                                className='timeline-item meta'>
                                <div>{format(new Date(t.ts), "Pp")}</div>
                                <div>{properCase(t.type.replace('-', ' '))}</div>
                            </div>
                        )
                    })
                }
                </section>
            </div> */}
      <div className="g-space-1"></div>

      <div className="g-space-2"></div>

      {
        (content) &&
        <section className='mc-content'>
          {
            content.map(c => (
              <div key={c.id}>
                <ProgressContentItem
                  content={c}
                  allContent={content}
                  progress={progress} />
              </div>
            ))
          }
        </section>
      }
      <AllUploadsModal
        show={viewUploads}
        cancel={() => setViewUploads(false)}
        progress={progress} />
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage}
        onApprove={approveRef.current} />
      <ModalConfirm
        show={confirmMessage}
        cancel={() => setConfirmMessage(null)}
        message={confirmMessage}
        onApprove={approveRef.current} />
    </div>

  )
}

export default ProgressDisplayContainer